// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-boundary .background {
  clip-path: polygon(100% 0, 100% 0, 100% 100%, 55% 100%);
}
.error-boundary .error-panel-container .logo {
  height: 90px;
  padding: 25px 0 0 40px;
  margin-bottom: 222px;
}
.error-boundary .error-panel-container .logo .logo-image {
  height: 100%;
}
.error-boundary .error-panel-container .error-panel {
  margin-left: 13%;
  width: 34%;
  min-width: 400px;
  font-weight: 700;
}
.error-boundary .error-panel-container .error-panel .error-panel-header {
  color: #426bac;
  font-weight: 700;
  font-size: 32px;
}
.error-boundary .error-panel-container .error-panel .error-header-subtitle {
  font-size: 24px;
  color: #5d6874;
  margin-bottom: 50px;
}
.error-boundary .error-panel-container .error-panel .panel-separator {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  display: block;
  margin-bottom: 50px;
}
.error-boundary .error-panel-container .error-panel .error-panel-details {
  margin-bottom: 60px;
}
.error-boundary .error-panel-container .error-panel .error-panel-details .error-details-header {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 700;
  color: #393838;
}
.error-boundary .error-panel-container .error-panel .error-panel-details .error-details-description {
  font-weight: 400;
  font-size: 16px;
}
.error-boundary .error-panel-container .error-panel .button {
  background-color: #426bac;
  border: 0;
  border-radius: 2px;
  color: #fff;
  cursor: pointer;
  font-size: 16px;
  margin: 0;
  outline: none;
  padding: 10px 59px;
  min-height: 40px;
  min-width: 300px;
}
@media (max-width: 575.98px) {
  .error-boundary .error-panel-container .error-panel {
    margin: auto;
  }
}`, "",{"version":3,"sources":["webpack://./application/shared/components/errorBoundary/styles.scss"],"names":[],"mappings":"AAAA;EACE,uDAAuD;AACzD;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,2CAA2C;EAC3C,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;EACf,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[".error-boundary .background {\n  clip-path: polygon(100% 0, 100% 0, 100% 100%, 55% 100%);\n}\n.error-boundary .error-panel-container .logo {\n  height: 90px;\n  padding: 25px 0 0 40px;\n  margin-bottom: 222px;\n}\n.error-boundary .error-panel-container .logo .logo-image {\n  height: 100%;\n}\n.error-boundary .error-panel-container .error-panel {\n  margin-left: 13%;\n  width: 34%;\n  min-width: 400px;\n  font-weight: 700;\n}\n.error-boundary .error-panel-container .error-panel .error-panel-header {\n  color: #426bac;\n  font-weight: 700;\n  font-size: 32px;\n}\n.error-boundary .error-panel-container .error-panel .error-header-subtitle {\n  font-size: 24px;\n  color: #5d6874;\n  margin-bottom: 50px;\n}\n.error-boundary .error-panel-container .error-panel .panel-separator {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  display: block;\n  margin-bottom: 50px;\n}\n.error-boundary .error-panel-container .error-panel .error-panel-details {\n  margin-bottom: 60px;\n}\n.error-boundary .error-panel-container .error-panel .error-panel-details .error-details-header {\n  margin-bottom: 10px;\n  font-size: 16px;\n  font-weight: 700;\n  color: #393838;\n}\n.error-boundary .error-panel-container .error-panel .error-panel-details .error-details-description {\n  font-weight: 400;\n  font-size: 16px;\n}\n.error-boundary .error-panel-container .error-panel .button {\n  background-color: #426bac;\n  border: 0;\n  border-radius: 2px;\n  color: #fff;\n  cursor: pointer;\n  font-size: 16px;\n  margin: 0;\n  outline: none;\n  padding: 10px 59px;\n  min-height: 40px;\n  min-width: 300px;\n}\n@media (max-width: 575.98px) {\n  .error-boundary .error-panel-container .error-panel {\n    margin: auto;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
